"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _myRelations = require('shared/selectors/myRelations');
var _hooks = require('./hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks3 = require('web/services/hooks');

var _App = require('web/screens/App');
var _RightSide = require('web/components/RightSide');
var _Navigation = require('./Navigation'); var _Navigation2 = _interopRequireDefault(_Navigation);
var _Profile = require('web/screens/Settings/Profile'); var _Profile2 = _interopRequireDefault(_Profile);
var _OrgsList = require('web/screens/Settings/OrgsList'); var _OrgsList2 = _interopRequireDefault(_OrgsList);
var _Org = require('web/screens/Settings/Org'); var _Org2 = _interopRequireDefault(_Org);
var _Account = require('web/screens/Settings/Account'); var _Account2 = _interopRequireDefault(_Account);
var _Security = require('web/screens/Settings/Security'); var _Security2 = _interopRequireDefault(_Security);
var _Notifications = require('web/screens/Settings/Notifications'); var _Notifications2 = _interopRequireDefault(_Notifications);
var _TemplatesMoved = require('web/screens/Settings/TemplatesMoved'); var _TemplatesMoved2 = _interopRequireDefault(_TemplatesMoved);

const SettingsPage = () => {
  const memberOrgs = _hooks3.useAppSelector.call(void 0, state => _myRelations.selectMyRelationshipGroups.call(void 0, state).memberOrgs)
  const { pathname } = _reactrouterdom.useLocation.call(void 0, )
  const isInPage = !_reactrouterdom.useRouteMatch.call(void 0, ).isExact

  const {
    gotoSettingsRoot,
    gotoOrgsList,
    gotoOrgInfo,
    gotoOrgMembers,
    gotoOrgMembership,
    gotoOrgSubscriptions,
    gotoAccountTab,
    gotoAccountSettings,
    gotoOrgConsent,
    gotoOrgBranding,
  } = _hooks.useNav.call(void 0, )

  const {
    accountFor, managedAccounts, isLoading: isAccountsLoading, hasFailed: hasAccountsLoadFailed, reload: reloadAccounts,
  } = _hooks.useAccounts.call(void 0, )
  const [firstAccount] = managedAccounts

  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  _react.useEffect.call(void 0, 
    () => {
      _actions2.default.getQuickLoginUsers()
        .catch(() => showWarningBar('Failed to load Quick Login users'))
    },
    [showWarningBar],
  )

  return (
    _react2.default.createElement(_App.AppVertical, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      , _react2.default.createElement(_Navigation2.default, {
        memberOrgs: memberOrgs,
        managedAccounts: managedAccounts,
        isAccountsLoading: isAccountsLoading,
        pathname: pathname, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
      )
      ,  isInPage &&
        _react2.default.createElement(_RightSide.RightSide, { className: "settings-page", inView: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SETTINGS.PROFILE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
              , _react2.default.createElement(_Profile2.default, { gotoSettingsRoot: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
            )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SETTINGS.SECURITY, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
              , _react2.default.createElement(_Security2.default, { gotoSettingsRoot: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}} )
            )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SETTINGS.NOTIFICATIONS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
              , _react2.default.createElement(_Notifications2.default, {
                gotoSettingsRoot: gotoSettingsRoot,
                profileSettingsUrl: _routes2.default.SETTINGS.PROFILE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
              )
            )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SETTINGS.TEMPLATES, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
              , _react2.default.createElement(_TemplatesMoved2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 78}} )
            )
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.SETTINGS.ORGS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
              , _react2.default.createElement(_OrgsList2.default, {
                gotoOrg: gotoOrgMembers,
                gotoSettingsRoot: gotoSettingsRoot,
                memberOrgs: memberOrgs, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
              )
            )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SETTINGS.ORG_PAGE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
              , _react2.default.createElement(_Org2.default, {
                gotoOrgInfo: gotoOrgInfo,
                gotoOrgMembers: gotoOrgMembers,
                gotoOrgMembership: gotoOrgMembership,
                gotoOrgSubscriptions: gotoOrgSubscriptions,
                gotoAccountSettings: gotoAccountSettings,
                gotoOrgConsent: gotoOrgConsent,
                gotoOrgBranding: gotoOrgBranding,
                gotoOrgsList: gotoOrgsList, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
              )
            )
            ,  firstAccount && (
              _react2.default.createElement(_reactrouterdom.Redirect, { exact: true,
                from: _routes2.default.SETTINGS.ACCOUNT,
                to: _routes.makeRoute.call(void 0, _routes2.default.SETTINGS.ACCOUNT_PAGE, { orgKey: firstAccount.DefaultOrgKey }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
              )
            )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SETTINGS.ACCOUNT_PAGE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
              , _react2.default.createElement(_Account2.default, {
                accountFor: accountFor,
                hasLoadFailed: hasAccountsLoadFailed,
                onAccountChanged: reloadAccounts,
                gotoAccountTab: gotoAccountTab,
                gotoOrgInfo: gotoOrgInfo,
                gotoSettingsRoot: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
              )
            )
            , _react2.default.createElement(_reactrouterdom.Redirect, { exact: true,
              from: _routes2.default.SETTINGS.ORG_PAGE_NO_TAB,
              to: _routes2.default.SETTINGS.ORG_PAGE_DEFAULT_TAB, __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
            )
          )
        )
      
    )
  )
}

exports. default = _react.memo.call(void 0, SettingsPage)
